import { render, staticRenderFns } from "./dialogModule.vue?vue&type=template&id=2b9aa560&scoped=true&"
import script from "./dialogModule.vue?vue&type=script&lang=js&"
export * from "./dialogModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9aa560",
  null
  
)

export default component.exports